'use strict';

angular.module('study.dashboard')
    .config(['$stateProvider', 'RouteProvider', function ($stateProvider, RouteProvider) {
        $stateProvider.state(RouteProvider.create('dashboard.queries-status-report', {
            url: '/queries-status-report',
            component: 'queriesStatusReport',
            pageTitle: ['gettextCatalog', function (gettextCatalog) {
                return gettextCatalog.getString('Informe de estado de queries');
            }],
            permission: 'read queries status report',
        }));

        $stateProvider.state(RouteProvider.create('dashboard.queries-resolution-time-report', {
            url: '/queries-resolution-time-report',
            component: 'queriesResolutionTimeReport',
            pageTitle: ['gettextCatalog', function (gettextCatalog) {
                return gettextCatalog.getString('Informe de resolución de queries');
            }],
            permission: 'read queries resolution time report',
        }));

        $stateProvider.state(RouteProvider.create('dashboard.queries-distribution-report', {
            url: '/queries-distribution-report',
            component: 'queriesDistributionReport',
            pageTitle: ['gettextCatalog', function (gettextCatalog) {
                return gettextCatalog.getString('Informe de distribución de queries');
            }],
            permission: 'read queries distribution report',
        }));
    }]);
